import React, { useEffect, useState } from 'react';
import { getCampaigns, createCampaign } from '../../api';
import { useToast } from '../../components/Toast';

export default function AdminCampaigns() {
  const toast = useToast();
  const [campaigns, setCampaigns] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', year: 2026, start_date: '2026-01-01', end_date: '2026-12-31' });

  const load = () => getCampaigns().then(setCampaigns).catch(console.error);
  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try { await createCampaign(form); setShowForm(false); load(); }
    catch (err) { toast.error(err.message); }
  };

  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h1>Gestion des Trophées de l'Innovation</h1>
          <button onClick={() => setShowForm(!showForm)} className="btn btn-primary">
            {showForm ? 'Annuler' : 'Nouvelle édition'}
          </button>
        </div>

        {showForm && (
          <div className="card" style={{ marginBottom: 24 }}>
            <h3 style={{ marginBottom: 16 }}>Créer une édition</h3>
            <form onSubmit={handleCreate}>
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 12, marginBottom: 16 }}>
                <div><label className="form-label">Nom</label><input type="text" value={form.name} onChange={e => setForm(f => ({...f, name: e.target.value}))} className="form-input" required /></div>
                <div><label className="form-label">Année</label><input type="number" value={form.year} onChange={e => setForm(f => ({...f, year: parseInt(e.target.value)}))} className="form-input" /></div>
                <div><label className="form-label">Ouverture</label><input type="date" value={form.start_date} onChange={e => setForm(f => ({...f, start_date: e.target.value}))} className="form-input" /></div>
                <div><label className="form-label">Clôture</label><input type="date" value={form.end_date} onChange={e => setForm(f => ({...f, end_date: e.target.value}))} className="form-input" /></div>
              </div>
              <button type="submit" className="btn btn-accent">Créer</button>
            </form>
          </div>
        )}

        {campaigns.map(c => (
          <div key={c.id} className="card" style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div>
                <h3 style={{ marginBottom: 4 }}>{c.name}</h3>
                <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
                  <span className={`badge ${c.is_active ? 'badge-vert' : ''}`}>{c.is_active ? 'Active' : 'Terminée'}</span>
                  <span className="badge">{c.year}</span>
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: 'var(--primary)' }}>{c.participant_count}</div>
                <div style={{ fontSize: 12, color: 'var(--text-light)' }}>participants</div>
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16, fontSize: 13 }}>
              <div><span style={{ color: 'var(--text-light)' }}>Ouverture:</span> {c.start_date ? new Date(c.start_date).toLocaleDateString('fr-FR') : '-'}</div>
              <div><span style={{ color: 'var(--text-light)' }}>Clôture:</span> {c.end_date ? new Date(c.end_date).toLocaleDateString('fr-FR') : '-'}</div>
              <div><span style={{ color: 'var(--text-light)' }}>Jurés:</span> {c.jury?.length || 0}</div>
            </div>

            {c.jury && c.jury.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12, color: 'var(--text-light)', marginBottom: 6 }}>Membres du jury:</div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {c.jury.map((j, i) => (
                    <span key={i} className="badge" style={{ fontSize: 11 }}>{j.first_name} {j.last_name}</span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
